import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const ItemListModalPr = ({ showModal, closeModal, branch, supplierCode, fld_purnumber, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allSuppliers, setAllSuppliers] = useState([]); // Store full data
  const [filteredSuppliers, setFilteredSuppliers] = useState([]); // Store filtered data
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showModal) {
      fetchSuppliers();
    }
  }, [showModal]);

  const fetchSuppliers = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/prPurchase_items", {
        params: { branchcode: branch, supplierCode: supplierCode, fld_purnumber:fld_purnumber },
      });
      setAllSuppliers(response.data);
      setFilteredSuppliers(response.data); 
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSuppliers(allSuppliers);
    } else {
      const filtered = allSuppliers.filter(
        (item) =>
          item.itemmaster_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.itemmaster_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSuppliers(filtered);       
    }
  }, [searchTerm, allSuppliers]);

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Select Item</h3>

        <div className="search-filter">
          <p >Search Item :</p>
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type to search..."
          />
        </div>

        {loading && <p className="loading-text">Loading...</p>}

        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Select</th>
              </tr>
            </thead>
            <tbody>
              {filteredSuppliers.length > 0 ? (
                filteredSuppliers.map((item) => (
                  <tr key={item.itemmaster_code}>
                    <td>{item.itemmaster_code}</td>
                    <td>{item.itemmaster_name}</td>
                    <td>
                      <button className="select-btn" onClick={() => handleSelectItem(item)}>Select</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No results found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button className="close-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  );
};

export default ItemListModalPr;
